var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMail = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M22.7500644,5.98757528 C22.7500644,5.99478228 22.7500644,6.00198706 22.7500644,6.00918729 L22.7500644,18 C22.7500644,19.5142136 21.5142136,20.75 20,20.75 L4,20.75 C2.48578644,20.75 1.2499356,19.5142136 1.2499356,18 L1.2499356,6.00918729 C1.2499356,6.00198706 1.2499356,5.99478228 1.2499356,5.98757528 C1.25676558,4.4790322 2.4899301,3.25 4,3.25 L20,3.25 C21.5100699,3.25 22.7432344,4.4790322 22.7500644,5.98757528 L22.7500644,5.98757528 Z M21.1982399,5.64574039 C21.0439813,5.13019642 20.5629517,4.75 20,4.75 L4,4.75 C3.43704829,4.75 2.9560187,5.13019642 2.80176009,5.64574039 L12,12.0845083 L21.1982399,5.64574039 L21.1982399,5.64574039 Z M21.25,7.44049167 L12.4300968,13.6144239 C12.1718566,13.795192 11.8281434,13.795192 11.5699032,13.6144239 L2.75,7.44049167 L2.75,18 C2.75,18.6857864 3.31421356,19.25 4,19.25 L20,19.25 C20.6857864,19.25 21.25,18.6857864 21.25,18 L21.25,7.44049167 L21.25,7.44049167 Z"
  }));
};
export default SvgMail;